import Vue from 'vue';
import {
  Affix,
  Avatar,
  AutoComplete,
  Steps,
  Badge,
  Breadcrumb,
  Button,
  Calendar,
  Card,
  Cascader,
  Checkbox,
  Col,
  Collapse,
  ConfigProvider,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  FormModel,
  Icon,
  Input,
  Layout,
  List,
  LocaleProvider,
  Menu,
  message,
  Modal,
  Popconfirm,
  Popover,
  Progress,
  Radio,
  Row,
  Select,
  Spin,
  Switch,
  Tabs,
  Tag,
  Table,
  TimePicker,
  Upload,
  Tooltip,
  Pagination,
  Alert
} from 'ant-design-vue';
import VueI18n from 'vue-i18n';
import 'ant-design-vue/dist/antd.less';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import config from '../../package.json';
import '@/style/index.less';

Vue.config.productionTip = false;
Vue.use(VueI18n);

Vue.use(Affix);
Vue.use(Avatar);
Vue.use(AutoComplete);
Vue.use(Badge);
Vue.use(Breadcrumb);
Vue.use(Button);
Vue.use(Calendar);
Vue.use(Card);
Vue.use(Cascader);
Vue.use(Checkbox);
Vue.use(Col);
Vue.use(Collapse);
Vue.use(ConfigProvider);
Vue.use(DatePicker);
Vue.use(Divider);
Vue.use(Dropdown);
Vue.use(Form);
Vue.use(FormModel);
Vue.use(Icon);
Vue.use(Input);
Vue.use(Layout);
Vue.use(List);
Vue.use(LocaleProvider);
Vue.use(Menu);
Vue.use(Modal);
Vue.use(Popconfirm);
Vue.use(Popover);
Vue.use(Progress);
Vue.use(Radio);
Vue.use(Row);
Vue.use(Select);
Vue.use(Spin);
Vue.use(Steps);
Vue.use(Switch);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Table);
Vue.use(Tooltip);
Vue.use(TimePicker);
Vue.use(Upload);
Vue.use(Pagination);
Vue.use(Alert);

Vue.prototype.$info = Modal.info;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$message = message;
